module.exports = __webpack_public_path__ + "img/ug.36bf9e5.svg";